const namespace = "exams";

export const exams = `${namespace}_list`;
export const exams_select = `${namespace}_select`;
export const exams_category = `${namespace}_category_list`;
export const exams_category_select = `${namespace}_category_select`;
export const lesson_select = `${namespace}_select`;

export const topic_select = `${namespace}_topic_select`;
export const subject_select = `${namespace}_subject_select`;

export const level_select = `${namespace}_level_select`;
export const course_select = `${namespace}_course_select`;
